module.exports = __webpack_public_path__ + "static/media/mail-icon.20464c50.svg";